import type { FaireProductEntity } from "../../entity_types/product";

export const p_az2ex9ad55: FaireProductEntity = {
  token: "p_az2ex9ad55",
  type: "product",
  name: "18K Gold Plated Waterproof Stainless Steel Chain Necklace - 6948",
  brandToken: "b_4zc36e4kj9",
  brandName: "Mia Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/9a6b2bbb48780105e366bcb5471a16bdd680896b9a42c77ad0284f3669347a05.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa224160f1e58a440ebd8e2ff9efc56c2aa22cb673c27b6eff67376eeed0d8be.jpeg",
  ],
  priceDollars: 9.63,
  description:
    "Dainty 18K Gold Plated Stainless Steel Chain Multi Layer Cross Necklace.\n\n\n\nThis item is hypoallergenic, waterproof and tarnish-resistant.\n\n*To prolong the shine and finish of the gold plating, contact with chemicals such as lotions, perfumes, and cleaning products should be avoided.*\n\n\n",
  tags: [],
  msrpDollars: 38.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:22.762Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
